































































































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import LoadingIndicator from '@/components/LoadingIndicator'
import Modal from '@components/Modal'
import FormField from '@ui/FormBuilder/FormField'
import RecapHeader from '@ui/Recap/RecapHeader'
import RecapEditor from './RecapEditor'
import RecapUtility from '@utils/RecapUtility'

settings =
  name: 'OrganizerRecapEdit'

  vue:
    components: {
      LoadingIndicator,
      Modal,
      FormField,
      RecapHeader,
      RecapEditor,
    }

    data: ->
      recap: null
      error: null

      submitModal:
        show: false

    computed:
      recapsEndpointUrl: ->
        "api/v2/recaps/#{@$route.params.token}"

      inputPropsForPhotos: ->
        description: 'Upload photos of product in hands',
        uploadPath: "uploads/recaps/#{@$route.params.token}/recap_photo" unless @recap.published or @recap.submitted
        canRemove: !@recap.submitted
        useCloudinary: true

      totalRequiredQuestions: ->
        questions = RecapUtility.requiredQuestions @recap
        Object.keys(questions).length

      totalRequiredAnswers: ->
        answers = RecapUtility.requiredAnswers @recap
        Object.keys(answers).length

      totalValidPhotos: ->
        RecapUtility.validPhotos(@recap).length

      missingRequiredPhotos: ->
        Math.max 0, @recap.num_required_photos - @totalValidPhotos

      missingRequiredQuestions: ->
        Math.max 0, @totalRequiredQuestions - @totalRequiredAnswers

    mounted: ->
      @fetchRecap()

    methods:
      hiSave: ->
        await RecessAPI.put @recapsEndpointUrl, @recap

      hiUpload: (data) ->
        await @uploadCompleted data
        @fetchRecap()

      hiSubmit: ->
        @submitAndNavigate()

      hiPromptSubmit: ->
        if @missingRequiredPhotos or @missingRequiredQuestions
          @submitModal.show = true
        else
          @submitAndNavigate()

      fetchRecap: ->
        try
          { data } = await RecessAPI.get @recapsEndpointUrl
          @recap = JSON.parse(JSON.stringify(data))
        catch ex
          @error = ex.message

      uploadCompleted: (data) ->
        payload = { urls: data.images }
        payload.options = data.options if data.options?
        await RecessAPI.trigger @recapsEndpointUrl, 'upload_completed', payload

      submitAndNavigate: ->
        await @submit()
        @navToRecapShow()

      submit: ->
        await RecessAPI.trigger @recapsEndpointUrl, 'submit'

      navToRecapShow: ->
        @$router.push { name: 'OrganizerRecapShowPage', params: { token: @recap.token } }

    watch:
      recap: (recap) ->
        @$router.replace { name: 'OrganizerRecapShowPage', params: { token: recap.token } } if recap.published or recap.submitted

export default VueOptions.vue settings
